import React, { Component } from 'react';
import _ from 'lodash';
import * as QuizHelpers from '../../helpers/quiz';

class EmployeeBudget extends Component {
  state = {
    animate: ''
  }

  componentDidMount () {
    QuizHelpers.sendAnalyticsOnQuestion(`${this.props.route}`, 'Employee Budget');
    setTimeout(() => {
      this.setState({
        animate: 'fadeIn'
      });
    }, 600);
  }

  _handleSelectBudget (val) {
    const {quiz, stepMethods} = _.clone(this.props);
    let nextStep = quiz.step + 1;
    this.props.reducer(val);
    stepMethods.setStep(nextStep);
  }

  _prevStep () {
    window.history.go(-1);
  }

  render () {
    let ranges = [];
    if (this.props.quiz.fieldValues.FullTimeEmployees >= 50) {
      ranges = [
        '$200 - $300',
        '$300 - $400',
        '$400 - $500',
        '$500+'
      ];
    } else {
      ranges = [
        '$0 - $200',
        '$200 - $300',
        '$300 - $400',
        '$400+'
      ];
    }

    return (
      <section className={'p30 animate ' + this.state.animate}>
        <div className='wrap text-center'>
          <h3>What is your anticipated monthly employer contribution for each employee?</h3>
          <p className='form radio budget'>
            <input type='radio' name='budget' value='high'
              id='b01'
            /><label htmlFor='b01'
              onClick={(e) => this._handleSelectBudget(1)}>{ranges[0]}</label>
            <input type='radio' name='budget' value='low'
              id='b02'
            /><label htmlFor='b02'
              onClick={(e) => this._handleSelectBudget(2)}>{ranges[1]}</label>
            <input type='radio' name='budget' value='low'
              id='b03'
            /><label htmlFor='b03'
              onClick={(e) => this._handleSelectBudget(3)}>{ranges[2]}</label>
            <input type='radio' name='budget' value='low'
              id='b04'
            /><label htmlFor='b04'
              onClick={(e) => this._handleSelectBudget(4)}>{ranges[3]}</label>
          </p>
          <button
            className='btn back'
            onClick={this._prevStep}>Previous</button>
        </div>
      </section>
    );
  }
}

export default EmployeeBudget;



// WEBPACK FOOTER //
// ./src/components/Questions/EmployeeBudget.jsx